import { Injectable } from '@angular/core';
import { CoreListEnvelop } from '@mkp/shared/models';
import { BaseHttpResource } from '@mkp/shared/data-access';
import { LocationDto, LocationPatchBody, LocationPostBody } from '@mkp/location/models';

@Injectable({ providedIn: 'root' })
export class LocationResource extends BaseHttpResource<
  LocationDto,
  CoreListEnvelop<LocationDto>,
  LocationPostBody,
  LocationPatchBody
> {
  constructor() {
    super('location');
  }
}
